import { ReactNode } from "react";
import {
  Layout as AntdLayoutComponent,
  LayoutProps as AntdLayoutProps,
} from "antd";
import { BaseComponentProps, Variant } from "../types";
import "./BaseLayout.scss";

const { Header, Content, Footer, Sider } = AntdLayoutComponent;

export interface BaseLayoutProps
  extends Omit<AntdLayoutProps, "children">,
    BaseComponentProps {
  children: ReactNode;
  variant?: Variant;
  className?: string;
}

export const AntdLayout: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const layoutClass = ["antd-layout", `antd-layout--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <AntdLayoutComponent
      className={layoutClass}
      data-testid={testId}
      {...props}
    >
      {children}
    </AntdLayoutComponent>
  );
};

// 子组件
export const AntdHeader: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const headerClass = ["antd-header", `antd-header--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Header className={headerClass} data-testid={testId} {...props}>
      {children}
    </Header>
  );
};

export const AntdContent: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const contentClass = ["antd-content", `antd-content--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Content className={contentClass} data-testid={testId} {...props}>
      {children}
    </Content>
  );
};

export const AntdFooter: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const footerClass = ["antd-footer", `antd-footer--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Footer className={footerClass} data-testid={testId} {...props}>
      {children}
    </Footer>
  );
};

export const AntdSider: React.FC<BaseLayoutProps> = ({
  children,
  variant = "primary",
  className = "",
  testId,
  ...props
}) => {
  const siderClass = ["antd-sider", `antd-sider--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Sider className={siderClass} data-testid={testId} {...props}>
      {children}
    </Sider>
  );
};

export default AntdLayout;
